import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessPrompt } from "@/shared/types/api/business-mode.types"

export const getPromptApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessPrompt"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getPrompt: builder.query<BusinessPrompt | null, undefined>({
        query: () => `/api/v1/business/prompts`,
        providesTags: () => [{ type: "BusinessPrompt" as const }]
      })
    })
  })

export const { useGetPromptQuery } = getPromptApi
